import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const translations = {
  fr: {
    // Navbar
    'nav.home': 'Accueil',
    'nav.gift_cards': 'Cartes Cadeaux',
    'nav.login': 'Connexion',
    'nav.admin': 'Admin',
    'nav.my_bookings': 'Mes réservations',
    'nav.logout': 'Déconnexion',

    // Homepage
    'home.hero_badge': 'Sports nautiques électriques',
    'home.hero_title': "L'électrique au service",
    'home.hero_title_accent': 'de la glisse',
    'home.hero_desc': 'Location de Foil électrique, surf électrique, wingfoils, paddles',
    'home.hero_cta': 'Réserver maintenant',
    'home.hero_gift_cta': 'Offrir une carte cadeau',
    'home.sites_badge': 'NOS BASES',
    'home.sites_title': 'Choisissez votre spot',
    'home.explore_activities': 'Explorer les activités',
    'home.activities_at': 'ACTIVITÉS À',
    'home.our_experiences': 'Nos expériences',
    'home.view_all': 'Voir tout',
    'home.from': 'Dès',
    'home.duration': 'Durée:',
    'home.book': 'Réserver',
    'home.gift_badge': 'OFFRE SPÉCIALE',
    'home.gift_title': 'Offrez une carte cadeau',
    'home.gift_desc': 'Faites plaisir à vos proches avec une carte cadeau Riding Watt.',
    'home.gift_cta': 'Acheter une carte cadeau',
    'home.select_site': 'Sélectionnez une base',

    // Auth
    'auth.login': 'Connexion',
    'auth.register': 'Inscription',
    'auth.email': 'Email',
    'auth.password': 'Mot de passe',
    'auth.name': 'Nom complet',
    'auth.phone': 'Téléphone',
    'auth.submit_login': 'Se connecter',
    'auth.submit_register': "S'inscrire",
    'auth.switch_register': "Pas de compte ? S'inscrire",
    'auth.switch_login': 'Déjà un compte ? Se connecter',
    'auth.error_login': 'Email ou mot de passe incorrect',
    'auth.success_register': 'Compte créé avec succès',

    // Booking
    'booking.back': 'Retour',
    'booking.step_duration': 'Durée',
    'booking.step_quantity': 'Quantité',
    'booking.step_date': 'Date',
    'booking.step_slot': 'Créneau',
    'booking.step_confirm': 'Confirmation',
    'booking.select_duration': 'Choisir la durée',
    'booking.quantity': 'Nombre de places',
    'booking.select_date': 'Choisir une date',
    'booking.select_slot': 'Choisir un créneau',
    'booking.available': 'disponible(s)',
    'booking.no_slots': 'Aucun créneau disponible',
    'booking.loading_slots': 'Chargement des créneaux...',
    'booking.summary': 'Récapitulatif',
    'booking.unit_price': 'Prix unitaire',
    'booking.subtotal': 'Sous-total',
    'booking.promo_code': 'Code promo',
    'booking.gift_card': 'Carte cadeau',
    'booking.apply': 'Appliquer',
    'booking.discount': 'Réduction',
    'booking.remaining': 'Reste à payer',
    'booking.total': 'Total',
    'booking.pay_online': 'Payer en ligne',
    'booking.pay_onsite': 'Payer sur place',
    'booking.login_required': 'Connectez-vous pour réserver',

    // Admin
    'admin.title': 'Administration',
    'admin.super_admin': 'Super Admin',
    'admin.franchise': 'Franchise',
    'admin.all_sites': 'Tous les sites',
    'admin.filter_site': 'Filtrer par site',
    'admin.dashboard': 'Dashboard',
    'admin.bookings': 'Réservations',
    'admin.calendar': 'Calendrier',
    'admin.activities': 'Activités',
    'admin.resources': 'Ressources',
    'admin.clients': 'Clients',
    'admin.sites': 'Sites',
    'admin.gift_cards': 'Cartes Cadeaux',
    'admin.promos': 'Promos',
    'admin.homepage': "Page d'accueil",
    'admin.transactions': 'Transactions',
    'admin.settings': 'Paramètres',

    // Dashboard stats
    'admin.stat.bookings': 'Réservations',
    'admin.stat.confirmed': 'Confirmées',
    'admin.stat.pending': 'En attente',
    'admin.stat.onsite': 'Sur place',
    'admin.stat.clients': 'Clients',
    'admin.stat.revenue': 'Revenus',

    // Admin tables
    'admin.client': 'Client',
    'admin.activity': 'Activité',
    'admin.date': 'Date',
    'admin.time': 'Horaire',
    'admin.price': 'Prix',
    'admin.payment': 'Paiement',
    'admin.status': 'Statut',
    'admin.actions': 'Actions',
    'admin.confirmed': 'Confirmée',
    'admin.pending': 'En attente',
    'admin.waiting': 'Attente',
    'admin.link_sent': 'Lien envoyé',
    'admin.cancelled': 'Annulée',
    'admin.online': 'En ligne',
    'admin.onsite': 'Sur place',
    'admin.admin': 'Admin',
    'admin.link': 'Lien',
    'admin.no_bookings': 'Aucune réservation',
    'admin.new_booking': 'Nouvelle réservation',
    'admin.new': 'Nouvelle',
    'admin.save': 'Enregistrer',
    'admin.cancel': 'Annuler',
    'admin.delete': 'Supprimer',
    'admin.edit': 'Modifier',
    'admin.create': 'Créer',
    'admin.search': 'Rechercher...',
    'admin.name': 'Nom',
    'admin.description': 'Description',
    'admin.photo': 'Photo',
    'admin.upload_click': 'Cliquez pour uploader',
    'admin.upload_formats': 'JPG, PNG, WEBP (max 25MB)',
    'admin.compression': 'Compression...',
    'admin.active': 'Actif',
    'admin.inactive': 'Inactif',
    'admin.slots_per_time': 'Places/créneau',
    'admin.linked_resource': 'Ressource liée',
    'admin.none': 'Aucune',
    'admin.durations_prices': 'Durées et tarifs',
    'admin.add': 'Ajouter',
    'admin.edit_activity': "Modifier l'activité",
    'admin.edit_details': 'Modifiez les détails',
    'admin.new_activity': 'Nouvelle activité',
    'admin.site': 'Site',
    'admin.type': 'Type',
    'admin.quantity': 'Quantité',
    'admin.export_csv': 'Export CSV',
    'admin.from_date': 'Du',
    'admin.to_date': 'Au',
    'admin.amount': 'Montant',
    'admin.balance': 'Solde',
    'admin.code': 'Code',
    'admin.edit_site': 'Modifier le site',
    'admin.city': 'Ville',
    'admin.address': 'Adresse',
    'admin.phone': 'Téléphone',
    'admin.email': 'Email',
    'admin.hours': 'Horaires',

    // Homepage editor
    'admin.hp.hero_image': 'Image de fond Hero',
    'admin.hp.logo': 'Logo',
    'admin.hp.badge': 'Badge',
    'admin.hp.title': 'Titre',
    'admin.hp.title_accent': 'Titre accent',
    'admin.hp.description': 'Description',
    'admin.hp.cta_button': 'Bouton CTA',
    'admin.hp.gift_button': 'Bouton Carte Cadeau',
    'admin.hp.saving': 'Enregistrement...',
    'admin.hp.saved': 'Page d\'accueil mise à jour',

    // Settings
    'admin.settings.payment': 'Paiement',
    'admin.settings.email': 'Email',
    'admin.settings.stripe_key': 'Clé Stripe',
    'admin.settings.resend_key': 'Clé Resend',
    'admin.settings.sender_email': 'Email expéditeur',
    'admin.settings.test_email': 'Tester l\'email',
    'admin.settings.save': 'Sauvegarder',
    'admin.settings.saved': 'Paramètres sauvegardés',

    // Delete dialog
    'admin.delete_confirm_title': 'Confirmer la suppression',
    'admin.delete_confirm_desc': 'Êtes-vous sûr de vouloir supprimer',
    'admin.delete_irreversible': 'Cette action est irréversible.',

    // Gift cards page
    'gift.title': 'Cartes Cadeaux',
    'gift.subtitle': 'Offrez une expérience unique sur l\'eau',
    'gift.amount': 'Montant',
    'gift.recipient_name': 'Nom du destinataire',
    'gift.recipient_email': 'Email du destinataire',
    'gift.message': 'Message personnalisé',
    'gift.buy': 'Acheter',
    'gift.my_cards': 'Mes cartes cadeaux',
    'gift.no_cards': 'Aucune carte cadeau',
    'gift.balance': 'Solde',

    // Footer
    'footer.activities': 'ACTIVITÉS',
    'footer.our_sites': 'NOS BASES',
    'footer.contact': 'CONTACT',
    'footer.legal': 'Mentions légales',
    'footer.privacy': 'Confidentialité',
    'footer.terms': 'CGV',
    'footer.rights': 'Tous droits réservés',

    // Common
    'common.loading': 'Chargement...',
    'common.error': 'Erreur',
    'common.success': 'Succès',
    'common.close': 'Fermer',
    'common.confirm': 'Confirmer',
    'common.place': 'place',
    'common.places': 'places',
    'common.minutes': 'minutes',
    'common.hour': 'heure',
    'common.half_day': 'Demi-journée',
    'common.full_day': 'Journée',

    // Cookies
    'cookies.title': 'Gestion des cookies',
    'cookies.description': 'Nous utilisons des cookies pour améliorer votre expérience. En continuant, vous acceptez notre politique de cookies.',
    'cookies.learn_more': 'En savoir plus',
    'cookies.accept': 'Accepter',
    'cookies.refuse': 'Refuser',
  },
  en: {
    // Navbar
    'nav.home': 'Home',
    'nav.gift_cards': 'Gift Cards',
    'nav.login': 'Login',
    'nav.admin': 'Admin',
    'nav.my_bookings': 'My Bookings',
    'nav.logout': 'Logout',

    // Homepage
    'home.hero_badge': 'Electric Water Sports',
    'home.hero_title': 'Electric power for',
    'home.hero_title_accent': 'the ultimate ride',
    'home.hero_desc': 'Electric foil, electric surf, wingfoils, paddle board rentals',
    'home.hero_cta': 'Book now',
    'home.hero_gift_cta': 'Give a gift card',
    'home.sites_badge': 'OUR LOCATIONS',
    'home.sites_title': 'Choose your spot',
    'home.explore_activities': 'Explore activities',
    'home.activities_at': 'ACTIVITIES AT',
    'home.our_experiences': 'Our experiences',
    'home.view_all': 'View all',
    'home.from': 'From',
    'home.duration': 'Duration:',
    'home.book': 'Book',
    'home.gift_badge': 'SPECIAL OFFER',
    'home.gift_title': 'Give a gift card',
    'home.gift_desc': 'Treat your loved ones with a Riding Watt gift card.',
    'home.gift_cta': 'Buy a gift card',
    'home.select_site': 'Select a location',

    // Auth
    'auth.login': 'Login',
    'auth.register': 'Sign Up',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.name': 'Full Name',
    'auth.phone': 'Phone',
    'auth.submit_login': 'Log in',
    'auth.submit_register': 'Sign up',
    'auth.switch_register': "No account? Sign up",
    'auth.switch_login': 'Already have an account? Log in',
    'auth.error_login': 'Invalid email or password',
    'auth.success_register': 'Account created successfully',

    // Booking
    'booking.back': 'Back',
    'booking.step_duration': 'Duration',
    'booking.step_quantity': 'Quantity',
    'booking.step_date': 'Date',
    'booking.step_slot': 'Time Slot',
    'booking.step_confirm': 'Confirmation',
    'booking.select_duration': 'Select duration',
    'booking.quantity': 'Number of spots',
    'booking.select_date': 'Select a date',
    'booking.select_slot': 'Select a time slot',
    'booking.available': 'available',
    'booking.no_slots': 'No slots available',
    'booking.loading_slots': 'Loading slots...',
    'booking.summary': 'Summary',
    'booking.unit_price': 'Unit price',
    'booking.subtotal': 'Subtotal',
    'booking.promo_code': 'Promo code',
    'booking.gift_card': 'Gift card',
    'booking.apply': 'Apply',
    'booking.discount': 'Discount',
    'booking.remaining': 'Remaining',
    'booking.total': 'Total',
    'booking.pay_online': 'Pay online',
    'booking.pay_onsite': 'Pay on site',
    'booking.login_required': 'Log in to book',

    // Admin
    'admin.title': 'Administration',
    'admin.super_admin': 'Super Admin',
    'admin.franchise': 'Franchise',
    'admin.all_sites': 'All sites',
    'admin.filter_site': 'Filter by site',
    'admin.dashboard': 'Dashboard',
    'admin.bookings': 'Bookings',
    'admin.calendar': 'Calendar',
    'admin.activities': 'Activities',
    'admin.resources': 'Resources',
    'admin.clients': 'Clients',
    'admin.sites': 'Sites',
    'admin.gift_cards': 'Gift Cards',
    'admin.promos': 'Promos',
    'admin.homepage': 'Homepage',
    'admin.transactions': 'Transactions',
    'admin.settings': 'Settings',

    // Dashboard stats
    'admin.stat.bookings': 'Bookings',
    'admin.stat.confirmed': 'Confirmed',
    'admin.stat.pending': 'Pending',
    'admin.stat.onsite': 'On-site',
    'admin.stat.clients': 'Clients',
    'admin.stat.revenue': 'Revenue',

    // Admin tables
    'admin.client': 'Client',
    'admin.activity': 'Activity',
    'admin.date': 'Date',
    'admin.time': 'Time',
    'admin.price': 'Price',
    'admin.payment': 'Payment',
    'admin.status': 'Status',
    'admin.actions': 'Actions',
    'admin.confirmed': 'Confirmed',
    'admin.pending': 'Pending',
    'admin.waiting': 'Waiting',
    'admin.link_sent': 'Link sent',
    'admin.cancelled': 'Cancelled',
    'admin.online': 'Online',
    'admin.onsite': 'On-site',
    'admin.admin': 'Admin',
    'admin.link': 'Link',
    'admin.no_bookings': 'No bookings',
    'admin.new_booking': 'New booking',
    'admin.new': 'New',
    'admin.save': 'Save',
    'admin.cancel': 'Cancel',
    'admin.delete': 'Delete',
    'admin.edit': 'Edit',
    'admin.create': 'Create',
    'admin.search': 'Search...',
    'admin.name': 'Name',
    'admin.description': 'Description',
    'admin.photo': 'Photo',
    'admin.upload_click': 'Click to upload',
    'admin.upload_formats': 'JPG, PNG, WEBP (max 25MB)',
    'admin.compression': 'Compressing...',
    'admin.active': 'Active',
    'admin.inactive': 'Inactive',
    'admin.slots_per_time': 'Spots/slot',
    'admin.linked_resource': 'Linked resource',
    'admin.none': 'None',
    'admin.durations_prices': 'Durations & prices',
    'admin.add': 'Add',
    'admin.edit_activity': 'Edit activity',
    'admin.edit_details': 'Edit details',
    'admin.new_activity': 'New activity',
    'admin.site': 'Site',
    'admin.type': 'Type',
    'admin.quantity': 'Quantity',
    'admin.export_csv': 'Export CSV',
    'admin.from_date': 'From',
    'admin.to_date': 'To',
    'admin.amount': 'Amount',
    'admin.balance': 'Balance',
    'admin.code': 'Code',
    'admin.edit_site': 'Edit site',
    'admin.city': 'City',
    'admin.address': 'Address',
    'admin.phone': 'Phone',
    'admin.email': 'Email',
    'admin.hours': 'Hours',

    // Homepage editor
    'admin.hp.hero_image': 'Hero background image',
    'admin.hp.logo': 'Logo',
    'admin.hp.badge': 'Badge',
    'admin.hp.title': 'Title',
    'admin.hp.title_accent': 'Accent title',
    'admin.hp.description': 'Description',
    'admin.hp.cta_button': 'CTA Button',
    'admin.hp.gift_button': 'Gift Card Button',
    'admin.hp.saving': 'Saving...',
    'admin.hp.saved': 'Homepage updated',

    // Settings
    'admin.settings.payment': 'Payment',
    'admin.settings.email': 'Email',
    'admin.settings.stripe_key': 'Stripe Key',
    'admin.settings.resend_key': 'Resend Key',
    'admin.settings.sender_email': 'Sender email',
    'admin.settings.test_email': 'Test email',
    'admin.settings.save': 'Save',
    'admin.settings.saved': 'Settings saved',

    // Delete dialog
    'admin.delete_confirm_title': 'Confirm deletion',
    'admin.delete_confirm_desc': 'Are you sure you want to delete',
    'admin.delete_irreversible': 'This action cannot be undone.',

    // Gift cards page
    'gift.title': 'Gift Cards',
    'gift.subtitle': 'Give a unique experience on the water',
    'gift.amount': 'Amount',
    'gift.recipient_name': 'Recipient name',
    'gift.recipient_email': 'Recipient email',
    'gift.message': 'Personal message',
    'gift.buy': 'Buy',
    'gift.my_cards': 'My gift cards',
    'gift.no_cards': 'No gift cards',
    'gift.balance': 'Balance',

    // Footer
    'footer.activities': 'ACTIVITIES',
    'footer.our_sites': 'OUR LOCATIONS',
    'footer.contact': 'CONTACT',
    'footer.legal': 'Legal notice',
    'footer.privacy': 'Privacy policy',
    'footer.terms': 'Terms',
    'footer.rights': 'All rights reserved',

    // Common
    'common.loading': 'Loading...',
    'common.error': 'Error',
    'common.success': 'Success',
    'common.close': 'Close',
    'common.confirm': 'Confirm',
    'common.place': 'spot',
    'common.places': 'spots',
    'common.minutes': 'minutes',
    'common.hour': 'hour',
    'common.half_day': 'Half day',
    'common.full_day': 'Full day',

    // Cookies
    'cookies.title': 'Cookie management',
    'cookies.description': 'We use cookies to improve your experience. By continuing, you accept our cookie policy.',
    'cookies.learn_more': 'Learn more',
    'cookies.accept': 'Accept',
    'cookies.refuse': 'Refuse',
  }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem('rw_lang');
    if (saved && translations[saved]) return saved;
    const browserLang = navigator.language?.slice(0, 2);
    return browserLang === 'en' ? 'en' : 'fr';
  });

  useEffect(() => {
    localStorage.setItem('rw_lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((key) => {
    return translations[lang]?.[key] || translations['fr']?.[key] || key;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useTranslation() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useTranslation must be used within LanguageProvider');
  return ctx;
}
